const LOGIN_ENDPOINT_KEY = 'LOGIN';

function checkException(data, commit) {
  if (data?.exceptionMessage) {
    commit('setError', { er: data });
    throw new Error(data.exceptionMessage);
  }
  return true;
}

async function getResource(url, login, password) {
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(`${login}:${password}`)))
      }
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.text();
    return text ? JSON.parse(text) : {};
  } catch (error) {
    throw new Error(`Authentication failed: ${error.message}`);
  }
}

export default {
  actions: {
    async login({ dispatch, commit, getters }, { login, password }) {
      try {
        const loginUrl = getters.const(LOGIN_ENDPOINT_KEY);
        const data = await getResource(loginUrl, login, password);
        return checkException(data, commit);
      } catch (error) {
        commit('setError', { er: error, source: ["actions", "login"] });
        throw error;
      }
    },
    async logout({ commit }) {
      commit('CLEAR_INFO');
    },
    /*checkAuthentication({ dispatch }) {
     
      let result;
      if (sessionStorage.session) {
        if (localStorage.login && localStorage.password) {
          const formData = {
            login: localStorage.login,
            password: localStorage.password,
          };
          dispatch("fetchInfo", formData);
          result = true;
        } else {
          result = false;
        }
      } else if (localStorage.login && localStorage.password && localStorage.checked === 'true') {
        const formData = {
          login: localStorage.login,
          password: localStorage.password,
        };
        dispatch("fetchInfo", formData);
        result = true;
      } else {
        result = false;
      }

      return result;
    },*/
  },
};